import styled from 'styled-components';
import Page from 'components/Page';

export default styled(Page)`
  max-width: 65rem;
  margin: 0 auto;
`;
